/**
 * Notification Preferences API Service
 *
 * Wraps the backend `/api/notification-preferences` endpoints for the per-user
 * scheduled-run email opt-in toggle.
 */

import { request } from '../../../shared/utils/api';

/**
 * Get the current user's notification preferences.
 * @returns {Promise<{scheduled_run_email_enabled: boolean}>}
 */
export const getNotificationPreferences = async () => {
  return request('/api/notification-preferences', 'GET');
};

/**
 * Update the scheduled-run email opt-in preference.
 * @param {boolean} enabled
 * @returns {Promise<Object>}
 */
export const setScheduledRunEmailEnabled = async (enabled) => {
  return request('/api/notification-preferences', 'PUT', {
    scheduled_run_email_enabled: !!enabled,
  });
};

/**
 * Update the delivery mode.
 * @param {'PER_RUN'|'DAILY_DIGEST'} mode
 * @returns {Promise<Object>}
 */
export const setScheduledRunEmailMode = async (mode) => {
  return request('/api/notification-preferences', 'PUT', {
    scheduled_run_email_mode: mode,
  });
};
